import { IHierarchyRole, IRole, ICurrentUser, IUser, IRoles } from '../domain/portal-domain';

const globalAdminRole = {
    name: 'administrator',
    hierarchyDisplayName: 'global',
    path: '',
};

const mapToRole = (role: IHierarchyRole): IRole => ({
    name: role.name,
    hierarchyDisplayName: role.hierarchyAssignmentDisplayPath,
    path: role.hierarchyAssignmentPath,
});

export const getUserWithRoles = (currentUser: ICurrentUser): IUser => {
    const globalRoles: IRole[] = currentUser.isGlobalAdmin ? [globalAdminRole] : [];
    const companyGroupRoles: IRole[] = currentUser.userRoles?.companyGroupsRoles?.map(mapToRole);
    const companyRoles: IRole[] = currentUser.userRoles?.companiesRoles?.map(mapToRole);
    const installationRoles: IRole[] = currentUser.userRoles?.installationRoles?.map(mapToRole);

    const roles = {
        global: globalRoles,
        companyGroup: companyGroupRoles,
        company: companyRoles,
        installation: installationRoles,
    } as IRoles;

    return {
        id: currentUser.id,
        name: (currentUser.firstName || '') + ' ' + (currentUser.lastName || ''),
        email: currentUser.email,
        isGlobalAdministrator: currentUser.isGlobalAdmin,
        isCompanyAdministrator: currentUser.isCompanyAdmin,
        roles,
        firstName: currentUser.firstName,
        lastName: currentUser.lastName,
        workTitle: currentUser.workTitle,
        signatureFileName: currentUser.signatureFileName,
        signatureFileUrl: currentUser.signatureFileUrl,
        phoneNumber: currentUser.phoneNumber,
    };
};
